export default __webpack_public_path__ + "static/media/instagram.e2cf34f0.png";